module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"brochure_img":"/Resources/Images/produits/BrochureFR_souche.jpg","pdf":"/Resources/Documents/RogneusesSouches-CMI_BrochureFR2024.pdf"},"en":{"brochure_img":"/Resources/Images/produits/BrochureEN_stump.jpg","pdf":"/Resources/Documents/StumpGrinders-CMI_BrochureENG2024.pdf"}}')
  delete Component.options._Ctor
}
